import { useEffect, useState } from 'react';
import { TrendingUp, TrendingDown, Activity } from 'lucide-react';
import { MarketIndex } from '../lib/supabase';
import { marketService } from '../lib/marketService';

export const MarketIndicesBanner = () => {
  const [indices, setIndices] = useState<MarketIndex[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadIndices();
    const interval = setInterval(loadIndices, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadIndices = async () => {
    try {
      const data = await marketService.getMarketIndices();
      setIndices(data);
    } catch (error) {
      console.error('Error loading indices:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-[#0d1117] border-b border-slate-800/50 py-2">
        <div className="max-w-[1600px] mx-auto px-4">
          <div className="animate-pulse flex items-center space-x-8">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-5 bg-slate-800 rounded w-32"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#0d1117] border-b border-slate-800/50 py-2 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-4">
        <div className="flex items-center space-x-2 overflow-x-auto scrollbar-hide">
          <div className="flex items-center space-x-2 text-slate-500 flex-shrink-0">
            <Activity className="w-4 h-4" />
            <span className="text-xs font-medium">LIVE</span>
            <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></span>
          </div>

          <div className="h-4 w-px bg-slate-700 flex-shrink-0"></div>

          {indices.map((index) => {
            const isPositive = index.change >= 0;
            return (
              <div key={index.id} className="flex items-center space-x-3 flex-shrink-0 px-3">
                <span className="font-semibold text-sm text-slate-300">{index.code}</span>
                <span className="font-mono text-sm text-white">
                  {marketService.formatPrice(index.value)}
                </span>
                <div className={`flex items-center space-x-1 ${isPositive ? 'text-emerald-400' : 'text-red-400'}`}>
                  {isPositive ? <TrendingUp className="w-3.5 h-3.5" /> : <TrendingDown className="w-3.5 h-3.5" />}
                  <span className="font-mono text-xs font-medium">
                    {isPositive ? '+' : ''}{index.change_percent.toFixed(2)}%
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
